import React from "react";
import { formatMessage } from "lib/globalize-util";
import { makeStyles } from "@material-ui/core";

interface IProps {
    searchTerm: string;
    filters: Map<string, any>;
    type: string;
}

const useStyles = makeStyles({
    underline: {
        textDecoration: "underline",
        color: "#45d0c8",
    },
    content: {
        marginTop: "25px",
        marginLeft: "35px",
        color: "#000",
    },
    h1: {
        fontSize: "30px",
        marginBottom: "15px",
    },
    p1: {
        fontSize: "14px",
        marginBottom: "15px",
    },
    p2: {
        fontSize: "14px",
        marginBottom: "30px",
    },
    noResults: {
        textAlign: "center",
        padding: "20px 10px",
        fontSize: "20px",
    },
});

export const EmptyResults: React.FunctionComponent<IProps> = ({ searchTerm, filters, type }) => {
    const classes = useStyles();
    return shouldShowEmptyResults(filters, type) || searchTerm ? (
        <div className={classes.content}>
            <h1 className={classes.h1}>{formatMessage("No results found")}</h1>
            {searchTerm && (
                <p className={classes.p1}>{`${formatMessage("We couldn't find any results for")} ${searchTerm}.`}</p>
            )}
        </div>
    ) : (
        <div className={classes.noResults}>{formatMessage("No results found")}</div>
    );
};

export const isCustomListWithAllOption = (filters: Map<string, any>, type: string) =>
    type === "custom-list" && filters?.size === 1 && filters?.get("shared") === "all";

export const shouldShowEmptyResults = (filters: Map<string, any>, type: string) =>
    isCustomListWithAllOption(filters, type) ? false : filters?.size;

export const isResultEmpty = (results: any[], isFetching: boolean, filters: Map<string, any>) =>
    results?.length === 0 && !isFetching && filters?.size;
